enum PrintLabOrderType {
  Order = 'ORDER',
  Label = 'LABEL',
}

export default PrintLabOrderType
